import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NRKeyValueDataDisplay from '../../NRKeyValueDataDisplay/NRKeyValueDataDisplay';
import NRLink from '../../NRLink/NRLink';
import { CONSTANTS } from '../../../constants/constants';
import { useTheme } from '@mui/material/styles';
import { capitalizeFirstLetter } from '../../../utils/utils';
import React from 'react';
const { FULL_NAME, SHORT_IDENTIFIER, TYPE, SOURCE, NOTES, LINK_TOOLTIP, ADDITIONAL_INFORMATION } =
  CONSTANTS.TABLE.LICENSE_ISSUES_TABLE.LICENSE_ISSUE_DETAIL_DRAWER.DETAILS_SECTION;
const { DETAILS } = CONSTANTS.TABLE.LICENSE_ISSUES_TABLE.LICENSE_ISSUE_DETAIL_DRAWER.TABS;

function NRLicenseDetails({ scrollableId, license }) {
  const theme = useTheme();
  return (
    <Box id={scrollableId} sx={{ padding: theme.spacing(3, 0, 0) }}>
      <Typography variant="subtitle1" mb={theme.spacing(3)}>
        {capitalizeFirstLetter(DETAILS)}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: theme.spacing(3) }}>
        <NRKeyValueDataDisplay dataKey={FULL_NAME} value={license?.licenseName} keyWidth={'30%'} />
        <NRKeyValueDataDisplay dataKey={SHORT_IDENTIFIER} value={license?.spdxId} keyWidth={'30%'} />
        <NRKeyValueDataDisplay dataKey={TYPE} value={license?.licenseType} keyWidth={'30%'} />
        <NRKeyValueDataDisplay
          dataKey={SOURCE}
          value={<NRLink tooltipTitle={LINK_TOOLTIP} url={license?.url} />}
          keyWidth={'30%'}
          valueMaxWidth="100%"
        />
      </Box>
      <Typography mb={1} variant="subtitle1" children={NOTES} />
      <Typography color={'text.secondary'} children={license?.licenseNotes} variant={'body2'} />
      {!!license?.additionalInfoUrlsList?.length && (
        <>
          <Typography mb={1} mt={3} variant="subtitle1" children={ADDITIONAL_INFORMATION} />
          {license?.additionalInfoUrlsList?.map(e => (
            <NRKeyValueDataDisplay dataKey={null} value={<NRLink tooltipTitle={e} url={e} />} keyWidth={'0%'} minWidth={0} valueMaxWidth="100%" />
          ))}
        </>
      )}
    </Box>
  );
}

export default NRLicenseDetails;
